<!-- LA BOURREE DE PARIS -->
<section class="-mb-[1px] min-h-[500px] px-5 lg:px-20 pb-2 pt-20 w-full overflow-hidden relative bg-[url('assets/svg/element-2.svg')] bg-no-repeat bg-center bg-contain bg-white-tinted">
  <!-- <section class="min-h-[500px] px-5 lg:px-20 pb-2 pt-20 w-full overflow-hidden relative bg-white-tinted"> -->
  <div class="z-20 container h-full flex flex-col lg:flex-row">
    <div data-aos="fade-right" id="description" class="text-center items-center lg:w-1/2">
      <h1 class="text-4xl lg:text-6xl font-alice">L' Auvergne à Paris ...</h1>
      <p class="p-5 m-auto text-justify font-raleway font-normal">Découvrez La Bourrée de Paris, un groupe folklorique emblématique fondé en 1925 au cœur de la communauté auvergnate parisienne. Avec son héritage riche et sa passion pour les traditions populaires, La Bourrée de Paris célèbre la culture des sept départements de la Ligue Auvergnate et du Massif Central à travers des spectacles de danse, de musique et de chant. Parcourant le monde avec ses jeunes talents, le groupe a enchanté les audiences dans plus de 30 pays, partageant avec fierté l'authenticité de son terroir et la beauté de ses traditions.</p>
    </div>
    <img data-aos="fade-left" alt="Une joueuse de cabrette au premier plan avec derriere d'autre musicien" class="h-[500px] w-full lg:w-1/2 object-cover" src="assets/images/photo-4.webp">
  </div>
</section>

<!-- DIVIDER -->
<div class=".custom-shape-divider-top-1728666158 w-full fill-white-tinted bg-blue-dark -mb-[1px]">
  <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 115">
    <path class="cls-1" d="M1002.5,0v36.08c-66.42,71.17-144.57,99.42-240.73,61.65-122.16-44.41-241.75-62.65-357.78-44.45C171.18,97.64,179.09,38.2,0,15.52V0h1002.5Z"/>
  </svg>
</div>

<!-- EVENEMENTS -->
@if (evenements) {
  <section class="bg-blue-dark lg:p-20 lg:pt-2 w-full overflow-hidden p-5">
    <div class="container">
      <h2 data-aos="zoom-out" class="pb-16 text-center text-4xl lg:text-6xl text-neutral-100 font-alice font-medium">Nos événements</h2>
      <div class="w-full flex flex-col xl:flex-row gap-4">
        <div class="relative w-full xl:w-1/2 h-[400px]">
          @if(evenements[0]){
            <div data-aos="fade-up" class="w-full h-full relative shadow-md shadow-black rounded-xl">
              @if(evenements[0].image) {
                <img alt="{{ evenements[0].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="{{ evenements[0].image }}">
              }
              @else {
              <img alt="{{ evenements[0].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="assets/images/photo-1.jpg">
            }
            <div class="p-5 z-30 absolute bottom-0 flex flex-col">
              <div class="flex flex-row gap-2 mb-2">
                <span class="text-xl bg-opacity-80 bg-white p-2 pb-1 rounded-lg items-center font-alice font-bold">{{ evenements[0].dateDebut | date:'d MMM': 'Europe/Paris': 'fr-FR' }}</span>
              </div>
              <p class="text-3xl text-white font-raleway font-thin">{{ evenements[0].nom }}</p>
              <!-- <p class="text-white">{{ evenements[0].description | truncate:300 }}</p> -->
            </div>
            <div class="z-20 absolute bottom-0 w-full h-[200px] bg-gradient-to-t from-black to-transparent rounded-xl"></div>
          </div>
        }
      </div>
      <div class="relative  w-full xl:w-1/2 h-[400px] hidden sm:flex flex-row gap-4 ">
        @if(evenements[1]){
          <div data-aos="fade-up" data-aos-delay="200" class="w-1/2 h-full relative shadow-md shadow-black rounded-xl">
            @if(evenements[1].image) {
              <img alt="{{ evenements[1].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="{{ evenements[1].image }}">
            }
            @else {
            <img alt="{{ evenements[1].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="assets/images/photo-1.jpg">
          }
          <div class="p-5 z-30 absolute bottom-0 flex flex-col">
            <div class="flex flex-row gap-2 mb-2">
              <span class="text-xl bg-opacity-80 bg-white p-2 pb-1 rounded-lg items-center font-alice font-bold">{{ evenements[1].dateDebut | date:'d MMM': 'Europe/Paris': 'fr-FR' }}</span>
            </div>
            <p class="text-3xl text-white font-raleway font-thin">{{ evenements[1].nom }}</p>
            <!-- <p class="text-white">{{ evenements[1].description | truncate:300 }}</p> -->
          </div>
          <div class="z-20 absolute bottom-0 w-full h-[200px] bg-gradient-to-t from-black to-transparent rounded-xl"></div>
        </div>
      }
      @if(evenements[2]){
        <div data-aos="fade-up" data-aos-delay="400" class="w-1/2 h-full relative shadow-md shadow-black rounded-xl">
          @if(evenements[2].image) {
            <img alt="{{ evenements[2].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="{{ evenements[2].image }}">
          }
          @else {
          <img alt="{{ evenements[2].nom }}" class="z-10 absolute h-full w-full object-cover rounded-xl" src="assets/images/photo-1.jpg">
        }
        <div class="p-5 z-30 absolute bottom-0 flex flex-col">
          <div class="flex flex-row gap-2 mb-2">
            <span class="text-xl bg-opacity-80 bg-white p-2 pb-1 rounded-lg items-center font-alice font-bold">{{ evenements[2].dateDebut | date:'d MMM': 'Europe/Paris': 'fr-FR' }}</span>
          </div>
          <p class="text-3xl text-white font-raleway font-thin">{{ evenements[2].nom }}</p>
          <!-- <p class="text-white">{{ evenements[2].description | truncate:300 }}</p> -->
        </div>
        <div class="z-20 absolute bottom-0 w-full h-[200px] bg-gradient-to-t from-black to-transparent rounded-xl"></div>
      </div>
    }
  </div>
</div>
<div class="text-center mt-8" data-aos="fade-up" data-aos-delay="600">
  <a href="#_" routerLink="/evenements"
    class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-secondary">
    Voir tous les événements
    <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
    </svg>
  </a>
</div>
</div>
</section>
}


<!-- Section Actualités -->

<section class="bg-gray-50 lg:p-20 w-full overflow-hidden px-5 pt-20">
  <div class="container">
    <div class="text-center mb-12">
      <h2 class="pb-5 text-4xl lg:text-6xl text-blue-dark font-alice font-medium">Nos Actualités</h2>
      <!-- <p class="text-gray-600">Restez informé des dernières nouvelles de La Bourrée de Paris</p> -->
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      @for(actualite of actualites; track actualite.key; let i = $index) {
        <div data-aos="fade-up" [attr.data-aos-delay]="i * 200">
          <app-actualite-card [actualite]="actualite"></app-actualite-card>
        </div>
      }
    </div>

    <div class="text-center mt-8" data-aos="fade-up" data-aos-delay="600">
      <a href="#_" routerLink="/actualites"
        class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-secondary">
        Voir toutes les actualités
        <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
        </svg>
      </a>
    </div>
  </div>
</section>

<!-- PLAQUETTE -->
<section class="h-[500px] pt-20 w-full overflow-hidden -mb-[1px]">
  <div class="container h-full flex flex-col-reverse md:flex-row">
    <div class="relative h-[60%] md:w-1/2 md:h-full bottom-0">
      <div data-aos="zoom-out" data-aos-delay="000" class="absolute z-30 bottom-0 top-0 left-0 right-0 h-full flex items-end">
        <img alt="Femme détourée en costume auvergnat" class="w-full max-h-full object-contain" src="assets/images/perso_emilie.png">
      </div>
            <div data-aos="zoom-out-right" data-aos-delay="400" class="absolute z-20 bg-complementary rounded-xl
                        left-1/2 bottom-[5%] w-[100px] h-[60%] -ml-[100px]
                        xs:left-1/2 xs:w-[200px] xs:-ml-[150px]
                        sm:left-1/2 sm:w-[300px] sm:-ml-[200px]
                        md:left-1/2 md:w-[200px] md:-ml-[150px]
                        lg:left-1/2 lg:w-[300px] lg:-ml-[200px]
                        xl:left-1/2
                        ">
      </div>
            <div data-aos="zoom-out-left" data-aos-delay="400" class="absolute z-10 rounded-xl bg-complementary-light
                        left-1/2 bottom-[10%] w-[150px] h-[65%]
                        xs:left-1/2 xs:w-[200px]
                        sm:left-1/2 sm:w-[200px] 
                        md:left-1/2 md:w-[200px]
                        lg:left-1/2 lg:w-[200px]
                        xl:left-1/2
                        ">
      </div>
    </div>
    <div class="z-40 h-[40%] md:h-full md:w-1/2 flex m-auto mt-0 md:items-center">
      <div data-aos="fade-left" class="p-5 flex flex-col m-auto">
        <div class="pb-4">
          <h2 class="pb-5 text-center md:text-left text-4xl lg:text-6xl text-blue-dark font-alice font-medium">Nos prestations</h2>
          <p class="text-justify md:text-left bg-opacity-30 text-xs xs:text-base font-raleway font-medium text-blue-dark">La Bourrée de Paris offre une variété de prestations en passant par des spectacles dynamiques, des animations de marchés, maisons de retraite, etc. Découvrez toutes nos prestations en téléchargeant notre plaquette</p>
        </div>
        <div class="flex flex-row w-full">
          <a href="assets/pdf/flyer.pdf" download class="w-full box-border relative z-30 inline-flex items-center justify-center md:w-auto px-8 py-3 overflow-hidden font-bold text-white transition-all duration-300 bg-primary rounded-md cursor-pointer group ring-offset-2 ring-1 ring-blue-300 ring-offset-blue-200 hover:ring-offset-blue-500 ease focus:outline-none me-3">
            <span class="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
            <span class="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
            <span class="relative z-20 flex items-center text-sm">
              <svg class="w-5 h-5 me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1h-2m-1-5-4 5-4-5m9 8h0"/>
              </svg>
              Plaquette
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SEPARATEUR 2 -->
<section class="h-[300px] lg:h-[500px] xl:h-[600px] w-full overflow-hidden">
  <img alt="Gros plan sur le detail d'une main de femme tenant sa robe" class="h-full w-full object-cover" src="assets/images/photo-3.webp">
</section>

<!-- CONTACT -->
<section class="h-[500px] pt-20 w-full overflow-hidden -mb-[1px]">
  <div class="m-auto max-w-[1500px] h-full flex flex-col-reverse md:flex-row-reverse">
    <div class="relative h-[60%] md:w-1/2 md:h-full bottom-0">
      <div data-aos="zoom-out" data-aos-delay="000" class="absolute z-30 bottom-0 top-0 left-0 right-0 h-full flex items-end">
        <img alt="Image détourée d'un homme en costume traditionnel auvergnat" class="w-full max-h-full object-contain" src="assets/images/perso_lucas.png">
      </div>
            <div data-aos="zoom-out-left" data-aos-delay="400" class="absolute z-20 bg-complementary rounded-xl
                        left-1/2 bottom-[5%] w-[100px] h-[60%] -ml-[100px]
                        xs:left-1/2 xs:w-[200px] xs:-ml-[150px]
                        sm:left-1/2 sm:w-[300px] sm:-ml-[200px]
                        md:left-1/2 md:w-[200px] md:-ml-[150px]
                        lg:left-1/2 lg:w-[300px] lg:-ml-[200px]
                        xl:left-1/2
                        ">
      </div>
            <div data-aos="zoom-out-right" data-aos-delay="400"  class="absolute z-10 rounded-xl bg-complementary-light
                        left-1/2 bottom-[10%] w-[150px] h-[65%]
                        xs:left-1/2 xs:w-[200px]
                        sm:left-1/2 sm:w-[200px] 
                        md:left-1/2 md:w-[200px]
                        lg:left-1/2 lg:w-[200px]
                        xl:left-1/2
                        ">
      </div>
    </div>
    <div class="z-40 h-[40%] md:h-full md:w-1/2 flex m-auto mt-0 md:items-center">
      <div data-aos="fade-right" class="p-5 flex flex-col m-auto">
        <div class="pb-4">
          <h2 class="pb-5 text-center md:text-right text-4xl lg:text-6xl text-blue-dark font-alice font-medium">Nous contacter</h2>
          <p class="text-justify md:text-right bg-opacity-30 text-xs xs:text-base font-raleway font-medium text-blue-dark">Vous souhaitez faire appel au groupe pour un festival, une représentation, une animation, en France ou à l'étranger ? Contactez nous dès maintenant pour plus d'information ! Par mail en cliquant sur le bouton ci-dessous, ou par téléphone au <a href="tel:+33615256099" class="text-primary">06 15 25 60 99</a></p>
        </div>
        <div class="flex flex-row md:flex-row-reverse w-full">
          <a href="mailto:contact@labourree.com" class="w-full box-border relative z-30 inline-flex items-center justify-center md:w-auto px-8 py-3 overflow-hidden font-bold text-white transition-all duration-300 bg-primary rounded-md cursor-pointer group ring-offset-2 ring-1 ring-blue-300 ring-offset-blue-200 hover:ring-offset-blue-500 ease focus:outline-none">
            <span class="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
            <span class="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
            <span class="relative z-20 flex items-center text-sm">
              <svg class="w-5 h-5 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18.4 14.8-1.2-1.3a1.7 1.7 0 0 0-2.4 0l-.7.7a1.7 1.7 0 0 1-2.4 0l-1.9-1.9a1.7 1.7 0 0 1 0-2.4l.7-.6a1.7 1.7 0 0 0 0-2.5L9.2 5.6a1.6 1.6 0 0 0-2.4 0c-3.2 3.2-1.7 6.9 1.5 10 3.2 3.3 7 4.8 10.1 1.6a1.6 1.6 0 0 0 0-2.4Z"/></svg>
              Contactez-nous
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FB / IG / YT -->
<section class="bg-blue-dark p-10 w-full overflow-hidden">
  <div class="grid grid-cols-3 container mx-auto">
    <a href="https://www.facebook.com/LaBourreedeParis" target="_blank" rel="noopener noreferrer" aria-label="La Bourrée de Paris sur Facebook (nouvel onglet)" data-aos="fade-up" class="group">
      <svg class="w-14 h-14 text-white hover:text-neutral-200 mx-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clip-rule="evenodd"/>
      </svg>
    </a>

    <a href="https://www.instagram.com/la_bourree_de_paris/" target="_blank" rel="noopener noreferrer" aria-label="La Bourrée de Paris sur Instagram (nouvel onglet)" data-aos="fade-up" data-aos-delay="200" class="group">
      <svg class="w-14 h-14 text-white hover:text-neutral-200 mx-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path fill="currentColor" fill-rule="evenodd" d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" clip-rule="evenodd"/>
      </svg>
    </a>

    <a href="https://www.youtube.com/@la_bourree_de_paris" target="_blank" rel="noopener noreferrer" aria-label="La Bourrée de Paris sur YouTube (nouvel onglet)" data-aos="fade-up" data-aos-delay="400" class="group">
      <svg class="w-14 h-14 text-white hover:text-neutral-200 mx-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z" clip-rule="evenodd"/>
      </svg>
    </a>
  </div>
</section>

<!-- REPETITION 2 -->
<section class="bg-blue-dark overflow-hidden -mb-[1px]">
  <div class="h-[600px] w-full overflow-hidden">
    <app-consent-embed service="maps" title="Carte : salle de répétition de La Bourrée de Paris, 124 rue de Bagnolet, Paris 20e"
      [src]="mapsEmbedUrl" fallbackUrl="https://www.openstreetmap.org/search?query=124%20rue%20de%20Bagnolet%2075020%20Paris"
      fallbackLabel="Voir sur OpenStreetMap"></app-consent-embed>    </div>
    <div class="container p-10">
      <div data-aos="zoom-in" class="bg-white p-10 inline-block -mt-40 rounded-lg">
        <h2 class="text-left text-4xl lg:text-6xl text-blue-dark font-alice font-medium">Répétitions</h2>
        <p class="font-raleway font-medium text-blue-dark">Salle de répétition : <span class="font-semibold">124 Rue de Bagnolet, 75020 Paris</span></p>
        <p class="font-raleway font-medium text-blue-dark">Répétitions <span class="font-medium">tous les mercredi</span> (hors vacances scolaire de la zone C) <span class="font-medium">de 21h00 à 23h00</span></p>
      </div>
    </div>
  </section>

  <!-- PHOTOS -->
  <section class="bg-blue-dark overflow-hidden">
    <div class="m-auto grid gap-4 p-10 items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="000" class="rounded-3xl p-4 object-cover aspect-square" src="assets/images/photo-8.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="200" class="rounded-3xl p-4 object-cover aspect-square" src="assets/images/photo-9.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="400" class="rounded-3xl hidden sm:block p-4 object-cover aspect-square" src="assets/images/photo-10.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="600" class="rounded-3xl hidden sm:block p-4 object-cover aspect-square" src="assets/images/photo-11.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="000" class="rounded-3xl hidden md:block p-4 object-cover aspect-square" src="assets/images/photo-12.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="200" class="rounded-3xl hidden md:block p-4 object-cover aspect-square" src="assets/images/photo-13.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="400" class="rounded-3xl hidden lg:block p-4 object-cover aspect-square" src="assets/images/photo-14.jpg">
      <img alt="Image représentant le groupe de La Bourrée de Paris" data-aos="zoom-in" data-aos-delay="600" class="rounded-3xl hidden lg:block p-4 object-cover aspect-square" src="assets/images/photo-15.jpg">
    </div>
  </section>

  <!-- PARTENAIRE -->
  <section class="bg-white p-5 lg:p-20 lg:pb-5 w-full overflow-hidden">
    <div class="container">
      <h2 data-aos="fade-up" class="pb-5 text-center text-4xl lg:text-6xl text-blue-dark font-alice font-medium">Nos partenaires</h2>
      <div class="flex flex-col sm:flex-row text-center items-center gap-4">
        <div data-aos="fade-up" data-aos-delay="000" class="w-full sm:w-1/3">
          <img alt="Logo de la Ligue Auvergnate" src="assets/images/ligue_auvergnate.png" class="w-1/3 m-auto object-contain">
        </div>
        <div data-aos="fade-up" data-aos-delay="200" class="w-full sm:w-1/3">
          <img alt="Logo du CIOFF" src="assets/images/cioff.png" class="w-1/3 m-auto object-contain">
        </div>
        <div data-aos="fade-up" data-aos-delay="400" class="w-full sm:w-1/3">
          <img alt="Logo de la FFATP" src="assets/images/ffatp.png" class="w-1/3 m-auto object-contain">
        </div>
      </div>
    </div>
  </section>

  <!-- DIVIDER -->
  <div class="w-full fill-blue-dark bg-white -mb-[1px] overflow-hidden">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1020 100">
      <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
      <g>
        <g id="Calque_1">
          <g id="Calque_1-2" data-name="Calque_1">
            <path d="M-1,59.5l2.8.5,4.4.3s4.7.3,5,.3,4.2-.3,4.2-.3l3.1,1.2,8.3.5,11-.3,13.3-.3,18.4.2h38.3s1-1.4,1.7-1.2,2.6-.8,2.6-.8l1.9-.8,3.1-.7,3.1-.8,3.8-.2s6.3-.6,6.6-.6,3.6-.5,3.6-.5l3.8-.9,3.6-.8,4-1.1,3.4-1.7,3.1-1.4,3.1-1.5,2.4-1,1.5-1.8,1.1-.2,2.3-2.2,3.6-3,2.2-.8,1.8-.9.5-1.6,1.7-1,1.8-1.5,1.9-1.2,2.5-1.6s1.4-1.7,1.7-1.7,1.8-1.2,1.8-1.2l1-1.5,2.4-1.1,2.5-1.6,2.2-.8,1.9-.2,1.5-1,2.6-1.7,1.8-.9,2-.3,2.6-.7,2.3-.7,1.5-.9,2.6-.2,2.5-.3,2.3-.5,2.6-.8,4.9.2,1.8,1,2.8-.2s2.3-.6,2.6-.7,3.6-1.2,4.1-1.2,4.9-.8,4.9-.8l2.8-.2,3.3-1.5s2.5-.8,2.8-.8,2.8-1.6,3.2-1.7,2.7-1.5,2.7-1.5l3,.6h3.3c0-.1.3,1.4.3,1.4l3,1.6,2.7,2,4.1,3.2,3.8,2.8,3.3,2.2,2.7,2.3,2.5,1,2.6,1.4,2.7.7,3,1.7,3.2,1.7,3.2,3.3,1.7,1.5,1.4.6,2.4,1.2,2,.8,3.2,1.4,3.3,1.4,3.1.7,2.3.8,3.6.5,4,.2,3.4-.7,3.5-.6,3.1-.8s5.4-.2,5.7-.2,4.5-.8,4.5-.8c0,0,3.9-.6,4.1-.6s6-2.4,6-2.4l2.6.5,4.6,1.2,6.9,1.3,4.5.9,9.6,2.5,5.3,1.1,4.5,1.1,5.5,1.5,3.5.2,4,1.4,5.7,1.5,2.2,1.1s5.8-.4,6-.3,7.5-.2,7.5-.2c0,0,7.6.5,7.8.6s5.6,1.5,5.6,1.5l6.3,1.1s6.4-1.6,6.7-1.7,3.6-1,3.8-.9,5.8,0,5.8,0h5.7l3.4.8,4.7,1.5,5.2,1.8s4.2,1.5,4.4,1.6,4.7,1,4.7,1c0,0,4.1,1.4,4.3,1.4s4.3.5,4.4.6,5.9,1.4,5.9,1.4l5.2.8h5.8s2.4-1.4,2.6-1.4,4.9-2.1,4.9-2.1l4.7-2.3s5.1-2.7,5.4-2.8,3-2,3.2-2,2.8-1.5,3-1.5,3-1.6,3-1.6c0,0,3.1-1.7,3.3-1.7s2.5-.5,2.7-.5,2.1.3,2.1.3l2.6,1.1,2.6,1.1s4.3,1.1,4.6,1.1,5.2-.7,5.5-.6,4.5-.2,4.7-.2,4.7-.3,4.9-.3,3.5-.6,3.5-.6l7.1-.6s4.4-.4,4.5-.3,4.1.9,4.1.9c0,0,5.6,1.7,5.7,1.7s6.7,1.4,6.9,1.4,6,1.5,6.2,1.5,6.5,1.6,6.5,1.6l4.3,1.4,4.7,1.1s7.1.2,7.3.3,9.4,1.4,9.4,1.4c0,0,6.3,1.2,6.4,1.2s6.3.2,6.5.3,5.3,1.2,5.3,1.2c0,0,4.3,2,4.5,2s4.3,1.5,4.4,1.5,3.8.7,4.1.7,5.5.3,5.8.3,4.4-.5,4.8-.4,5.2-.5,5.6-.5,5.1-.9,5.1-.9l4.2-1.4,3.2-1.3,3-.5s2.8.1,3,.2,3.1.8,3.1.8l4.5,1s2.6.2,2.8.2,2.4-.7,2.4-.7l3.1-1.8,3.6-1.9,3.8-1.7s2.6-1.2,3-1.3,2.7-1,2.7-1h2.4c.2,0,2.1-1.5,2.1-1.5l1.7-.8,2.6.4,3.5.6s2.8.8,3.1.8,3.5.3,3.5.3c0,0,3.6-1.3,3.8-1.4s3.2-.4,3.2-.4c0,0,2.6-.8,2.8-.8s4.4-.9,4.4-.9l2.1.2,1.9,1.1,3.5,1.4,3.3.9,5.1,1.2,3.5,1.1,2.6,1.2s2.5-1.2,2.7-1.4,3.5-1.6,3.5-1.6l3.4-1.6,4.4-1.2,3-.5s5.6-.4,5.8-.5,5.5-.5,5.7-.3,6.7.3,6.9.3,6.1-.1,6.1-.1c0,0,4.3-.5,4.5-.5s4.4-.4,4.6-.4h5.6l4.2.2s4.8,1.8,5,1.8,4.2,1.9,4.2,1.9l3.4,2.3,2.7,1.8,3.4,2.7,2.2,1.5,2.8.2s2.4-.9,2.9-1,3.9-.5,3.9-.5l3.1-.3s4.2-.5,4.4-.5h4.9l4.9-.3s6.1.2,6.3.2,5-.2,5-.2c0,0,3.7-.7,4-.8s4-1.5,4-1.5l3.8-1.6,3.5-1.2h1.5c0,.1,2.3,1,2.3,1l3,1.3,2.8.6,4.4.4h12.9c0,.1,2.9-.5,2.9-.5,0,0,5.1-1.1,5.2-1.1s3.9-.2,3.9-.2c0,0,3.1.9,3.2.9s3.9.6,3.9.6c0,0,4.1.9,4.3.9s3.6.4,3.6.4c0,0,2.5-.6,2.7-.6s2.8-1.9,2.8-1.9l2.7-1.4h2.8c0-.1,5.1.1,5.5.1s4.6.2,4.8.3,3.7.2,4,.3,3.6.7,4.3.8,4,.7,4.3.7,2,.2,2,.2l4.8.8v42H-1v-41.1h0v-.2Z"/>
          </g>
        </g>
      </g>
    </svg>
  </div>

  <!-- NEWSLETTER -->
  <section class="min-h-[400px] md:h-[400px] bg-blue-dark overflow-hidden">
    <div class="m-auto max-w-[1500px] h-full flex flex-col md:flex-row">
      <div data-aos="fade-right" data-aos-delay="000" class="z-40 md:h-full md:w-1/2 p-4 flex m-auto mt-0 md:items-center">
        <div class="flex flex-col m-auto">
          <h2 class="pb-5 text-4xl lg:text-6xl text-center md:text-right font-extrabold font-alice mb-4 text-white-tinted">Rejoignez notre <span class="text-complementary">newsletter</span> !</h2>
          <form ngNativeValidate (ngSubmit)="onNewsletterSubmit()" class="flex flex-col gap-2 w-full">
            <div class="flex flex-row gap-2 w-full">
              <label for="newsletter-email" class="sr-only">Votre adresse email</label>
              <input id="newsletter-email" type="email" name="email" autocomplete="email" required
                [(ngModel)]="email" class="flex-grow rounded-xl" placeholder="Entrez votre adresse email">
              <button type="submit" [disabled]="newsletterSending" class="font-raleway font-bold hover:bg-complementary-light hover:text-blue-dark transition duration-500 ease-in-out bg-complementary text-blue-dark rounded-xl px-4">S'inscrire</button>
            </div>
            <div class="flex items-start gap-2 text-left">
              <input id="newsletter-consent" type="checkbox" name="consent" required
                [(ngModel)]="newsletterConsent" class="mt-1 h-5 w-5 shrink-0 rounded">
              <label for="newsletter-consent" class="text-sm font-raleway text-white-tinted">
                J'accepte de recevoir la newsletter de La Bourrée de Paris. Je peux me désinscrire à tout moment.
              </label>
            </div>
            <p class="text-xs font-raleway text-blue-light">
              Votre adresse email est utilisée uniquement pour vous envoyer la newsletter, sur la base de
              votre consentement, et conservée jusqu'à votre désinscription. Droits d'accès, de
              rectification et d'effacement : {{ association.email }}.
              <a href="/confidentialite" class="underline">Politique de confidentialité</a>.
            </p>
          </form>
        </div>
      </div>
      <div class="relative h-[250px] md:w-1/2 md:h-full bottom-0">
        <div data-aos="zoom-out" data-aos-delay="000" class="absolute z-30 bottom-0 top-0 left-0 right-0 h-full flex items-end">
          <img alt="Image détourée d'une femme en costume traditionnel auvergnat en train de danser" class="w-full max-h-full object-contain aspect-square" src="assets/images/perso_romy.png">
        </div>
            <div data-aos="zoom-out-left" data-aos-delay="400" class="absolute z-20 bg-complementary rounded-xl
                        left-1/2 bottom-[5%] w-[50px] h-[60%] -ml-[50px]
                        xs:left-1/2 
                        sm:left-1/2 sm:bottom-16
                        md:left-1/2 md:-ml-[100px] md:bottom-10 md:w-[100px] md:h-[300px]
                        lg:left-1/2 
                        xl:left-1/2 ">
        </div>
            <div data-aos="zoom-out-right" data-aos-delay="400" class="absolute z-10 rounded-xl bg-complementary-light
                        left-1/2 bottom-[10%] w-[99px] h-[75%]
                        xs:left-1/2 
                        sm:left-1/2 sm:bottom-16
                        md:left-1/2 md:bottom-[10%] md:-ml-[0px] md:w-[200px] md:h-[75%]
                        lg:left-1/2
                        xl:left-1/2 ">
        </div>
      </div>
    </div>
  </section>
  <app-toast></app-toast>